(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var video = document.querySelector('.landing_bg');
    if (!video) return;
    video.muted = true;
    var attempt = function () {
      video.play().catch(function () {});
    };
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      attempt();
    } else {
      document.addEventListener('DOMContentLoaded', attempt);
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('swiper-js').addEventListener('load', function () {
    new Swiper('.shop-swiper', {
      // loop: true,
      slidesPerView: 4,
      spaceBetween: 24,
      navigation: {
        prevEl: '.shop-slider__arrow.is--prev',
        nextEl: '.shop-slider__arrow.is--next',
      },
      breakpoints: {
        0: {
          slidesPerView: 1,
          spaceBetween: 32,
        },
        768: {
          slidesPerView: 4,
          spaceBetween: 48,
        },
      },
    });
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video"] && !Shopify.designMode) return;
  try {
    
  document.getElementById('swiper-js').addEventListener('load', function () {
    new Swiper('.video-swiper', {
      autoHeight: true,
      slidesPerView: 1,
      spaceBetween: 0,
      navigation: {
        prevEl: '.video-slider__arrow.is--prev',
        nextEl: '.video-slider__arrow.is--next',
      },
      // on: {
      //   slideChange: function () {
      //     document.querySelectorAll('.video-slide__iframe').forEach(function (iframe) {
      //       var src = iframe.src;
      //       iframe.src = '';
      //       iframe.src = src;
      //     });
      //   },
      // },
    });
  });

  } catch(e) { console.error(e); }
})();
})();
